console.time('speed Main js');
// Global area visibility
// Глобальная область видимости

// ***** Функционал для работы с куки (vanila js) док - https://www.w3schools.com/js/js_cookies.asp *****
// g-f-performer Установить куки
// cname - String, ключ куки для записи
// cvalue - String, значение куки для записи
// exdays - Number, количество дней жизни этого куки
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toGMTString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

//  g-f-performer получить куки
// cname - Имя ключа куки которое нужно получить
function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

// g-f-performer для  проверки наличия нужного кукиса
// cname - String, ключ куки которое нужно проверить
function checkCookie(cname) {
    var cValue = getCookie(cname);
    if (cValue != '') {
        return true;
    } else {
        return false;
    }
}

// *****конец Функционал для работы с куки (vanila js)*****

function prelloader() {
    if ($('body').children('.prelloader-box').length < 1) {
        $('body').append(
            '<div class="prelloader-box">' +
            '<div class="prelloader-spin">' +
            '<i class="fa fa-spinner fa-spin"></i>' +
            '</div>' +
            '</div>'
        );
    }
}

function removePrelloader() {
    $('body').children('.prelloader-box').remove();
}


//функция определения области клика на картинке в header
function setAriaClickImgHeader() {

    //в зависимости от размера экрана выбираем активное изображение
    if ($(window).width() >= 420) {
        var imageHeader = $('.big-img-header');
    } else {
        var imageHeader = $('.small-img-header');
    }

    // в зависимости от изображения высчитываем координаты блока
    var areaImgHeader, startClickArea, endClickArea;
    if ($(window).width() >= 420) {
        startClickArea = imageHeader.width() * 0.23;
        endClickArea = imageHeader.width() * 0.37;
        areaImgHeader = $('#area-phone-big');
    } else {
        startClickArea = imageHeader.width() * 0.28;
        endClickArea = imageHeader.width() * 0.56;
        areaImgHeader = $('#area-phone-small');
    }
    // устанавливаем значение координат в аттрибут
    areaImgHeader.attr('coords', '"' + startClickArea + ',' + 0 + ',' + endClickArea + ',' + imageHeader.height() + '"');
}

// Local area visibility
$(document).ready(function () {
    // Защита от копирования контента
    // Для применения раскоментировать код
    // (function() {
    //     // если в пути стриницы присутствует wellness-consultant или если в боди есть класс - wellness-consultant
    //     if (window.location.pathname.indexOf('wellness-consultant') == 1 || $('body').hasClass('wellness-consultant')) {
    //         // Ничего не делаем
    //         return false;
    //     }
    //     // или если это страницы профиля или страница регистрации новичка
    //     else if (window.location.pathname.indexOf('profile') == 1 || window.location.pathname.indexOf('business-registration') == 1) {
    //         // Ничего не делаем
    //         return false;
    //     }
    //     else {
    //         // Во всех остальных случаях включаем защиту от копирования
    //         document.getElementsByTagName('body')[0].oncopy = function(e) {
    //             return false;
    //         }
    //     }
    // })();
    // конец Защита от копирования контента

    // Функционал принудительного скрития плашки - Вы желаете поменять язык - из за кеша браузера
    (function () {
        // Если существует кука - wantlang
        if (checkCookie('bs_lang')) {
            // И если кука находиться именно в значении - hide
            if (getCookie('bs_lang') == '0') {
                // И если плашка существует на странице
                if ($('.wantlang').length > 0) {
                    // То скрываем ее
                    $('.wantlang').removeClass('sshow');
                }
            }
        }
        // И если плашка существует на странице
        if ($('.wantlang').length > 0) {
            // И если у нее значение data-coockie означает что она уже была показана
            if ($('.wantlang').attr('data-coockie') == 'yes') {
                // Устанавливаем свое куки для дальнейшего ее скрития
                setCookie('bs_lang', '0', 30);
            }
        }
    })();
    // конец Функционал принудительного скрития плашки - Вы желаете поменять язык

    // Показать/скрыть пароль
    $('.chform-vw').on('click', function () {
        if ($(this).hasClass('vw')) {
            $(this).removeClass('vw');
            $(this).siblings('.pass-input').attr('type', 'password');
        } else {
            $(this).addClass('vw');
            $(this).siblings('.pass-input').attr('type', 'text');
        }
    });

    // new js for open/close mobile menu
    $('#mob-btn').on('click', function (etg) {
        var thisButton = $(this);
        etg.stopPropagation();
        setTimeout(function () {
            thisButton.addClass('active');
            $('#mobile-menu').addClass('st-menu-open');
        }, 100);
    });
    $('#mobile-menu_btn_back').on('click', function (etg) {
        var thisButton = $(this);
        etg.stopPropagation();
        setTimeout(function () {
            thisButton.closest('#mobile-menu').removeClass('st-menu-open');
            $('#mob-btn').removeClass('active');
        }, 100);
    });

    /*
    (function () {
        // async init
        setTimeout(function () {
            if ($('.novelty-slider').length > 0) {
                var noveltySlider = new Swiper('.novelty-slider', {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    // Navigation arrows
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        993: {
                            slidesPerView: 2,
                            spaceBetween: 0,
                        },
                        1200: {
                            slidesPerView: 3,
                            spaceBetween: 0,
                        },
                    },
                });
            }
        }, 300);
    })();
     */

    /*** ============ modules recommendations clear textarea =========== ***/
    if ($('.reccomend-form').length > 0) {
        $('.reccomend-form')
            .find('textarea')
            .each(function () {
                var str = $(this).text();
                str = str.replace(/<br\s*[\/]?>/gi, '\n');
                str = str.replace(/(<([^>]+)>)/gi, '');
                $(this).text(str);
            });
    }

    /*** ============ Функция для елемента мобильного меню для вкладки wellness-beauty =========== ***/
    function wellnessMobMenu() {
        var wellnessLink = $('.mobile-menu_b_t').find('.wellnesmob').children('a');
        var winWidth = $(window).width();
        var wellnesDropMenu = $('.mobile-menu_b_t')
            .find('.wellnesmob')
            .children('ul.dropdown-menu');
        if (winWidth < 770) {
            if (wellnesDropMenu.length > 0) {
                wellnessLink.removeAttr('href');
            }
        }
    }

    $('.mobile-menu_b_t')
        .find('.wellnesmob')
        .children('a')
        .on('click', wellnessMobMenu);

    function downloader() {
        var body = document.querySelector('body');
        var elem =
            '<div class="downloader">' +
            '<div class="downloader__circle"></div>' +
            '<span class="downloader__percent"><span>15</span>%</span>' +
            '</div>';
        body.insertAdjacentHTML('afterBegin', elem);

        // Loader
        var downloader = document.querySelector('.downloader');
        var downloaderCircle = document.querySelector('.downloader__circle');
        var downloaderPercent = document.querySelector('.downloader__percent');
        body.style.overflow = 'hidden';
        downloader.style.cssText =
            '' +
            'width: 100%;' +
            'height: 100%;' +
            'background: rgba(255, 255, 255, 0.47);' +
            'position: fixed;' +
            'z-index: 9999';
        downloaderCircle.style.cssText =
            '' +
            'width:30px;' +
            'height: 30px;' +
            'margin: auto;' +
            'border: 2px solid rgba(139, 197, 63, 0.52);' +
            'border-right: 2px solid #8bc53f;' +
            'border-radius: 50%;' +
            'position: absolute;' +
            'top: 0;' +
            'right: 0;' +
            'bottom: 0;' +
            'left: 0;' +
            'animation: loader 2s infinite linear';
        downloaderPercent.style.cssText =
            '' +
            'display:block;' +
            'width:20px;' +
            'height: 20px;' +
            'margin: auto;' +
            'font-size: 10px;' +
            'line-height: 20px;' +
            'text-align: center;' +
            'position: absolute;' +
            'top: 0;' +
            'right: 0;' +
            'bottom: 0;' +
            'left: 0;';

        var timer = setInterval(function () {
            var per = downloaderPercent.querySelector('span');
            var count = parseFloat(per.innerText);
            if (count >= 100) {
                clearInterval(timer);
            }
            per.innerText = count + 1;
        }, 2000);
    }

    // js for prevent double form submission
    $('.modal-check-phone')
        .find('#w1')
        .on('submit', function (etg) {
            $(this).find('button[type="submit"]').last().prop('disabled', 'true');
            downloader();
        });

    // js for translating buttons into languages
    if (
        $('html').attr('lang') === 'ua-UA' ||
        $('html').attr('lang') === 'uk-UA'
    ) {
        $('.quests').find('.size-elem').addClass('ukr');
    }

    // js for control modal-confirm in doctors pages
    $('.modal-confirm')
        .find('.confmod')
        .on('click', function (etg) {
            if ($(this).hasClass('not-comment')) {
                etg.preventDefault();
            }
        });
    $('.modal-confirm')
        .find('#comment')
        .on('keyup', function (etg) {
            var forEmpty = /[^\s]/g;
            var detectEmpty = $(this).val().match(forEmpty);
            if (detectEmpty) {
                $('.modal-confirm').find('.confmod').removeClass('not-comment');
            } else {
                $('.modal-confirm').find('.confmod').addClass('not-comment');
            }
        });

    // js for detect isset seo-text and add style to it
    // function detectIssetSeotext() {
    //     if ($('.seo_text')[0]) {
    //         var seoText = $('.catalog_cnt').find('.seo_text');
    //         var ourBlock = $('.catalog ').find('.catalog_cnt_t_r');
    //         var ourBlockHeigth = ourBlock.height();
    //         var desiredPadding = ourBlockHeigth - 30;
    //         var forEmpty = /[^\s]/g;
    //         var detectEmpty = seoText.html().match(forEmpty);
    //         if ($(window).width() >= 770) {
    //             if (detectEmpty) {
    //                 seoText.addClass('isset-cont');
    //                 ourBlock.css('position', 'absolute');
    //                 $('#itemContainer').css('margin-top', desiredPadding + 'px');
    //                 $('.catalog ').find('.catalog_cnt_t').css('margin-bottom', '30px');
    //             }
    //         } else {
    //             if (detectEmpty) {
    //                 seoText.addClass('isset-cont');
    //                 ourBlock.css('position', 'static');
    //                 $('#itemContainer').css('margin-top', '0');
    //                 $('.catalog ').find('.catalog_cnt_t').css('margin-bottom', '16px');
    //             }
    //         }
    //     }
    // }

    // detectIssetSeotext();
    // setTimeout(detectIssetSeotext, 500);
    // $(window).on('resize', detectIssetSeotext);

    /*
    // for detect Browser whitch js
    function getBrowser() {
        var ua = navigator.userAgent;
        var bName = (function () {
            if (ua.search(/Edge/) > -1) return 'edge';
            if (ua.search(/MSIE/) > -1) return 'ie';
            if (ua.search(/Trident/) > -1) return 'ie11';
            if (ua.search(/Firefox/) > -1) return 'firefox';
            if (ua.search(/Opera/) > -1) return 'opera';
            if (ua.search(/OPR/) > -1) return 'operaWebkit';
            if (ua.search(/YaBrowser/) > -1) return 'yabrowser';
            if (ua.search(/Chrome/) > -1) return 'chrome';
            if (ua.search(/Safari/) > -1) return 'safari';
            if (ua.search(/Maxthon/) > -1) return 'maxthon';
        })();
        var version;
        switch (bName) {
            case 'edge':
                version = ua.split('Edge')[1].split('/')[1];
                break;
            case 'ie':
                version = ua.split('MSIE ')[1].split(';')[0];
                break;
            case 'ie11':
                bName = 'ie';
                version = ua.split('; rv:')[1].split(')')[0];
                break;
            case 'firefox':
                version = ua.split('Firefox/')[1];
                break;
            case 'opera':
                version = ua.split('Version/')[1];
                break;
            case 'operaWebkit':
                bName = 'opera';
                version = ua.split('OPR/')[1];
                break;
            case 'yabrowser':
                version = ua.split('YaBrowser/')[1].split(' ')[0];
                break;
            case 'chrome':
                version = ua.split('Chrome/')[1].split(' ')[0];
                break;
            case 'safari':
                version = ua.split('Version/')[1].split(' ')[0];
                break;
            case 'maxthon':
                version = ua.split('Maxthon/')[1];
                break;
        }
        var platform = 'desktop';
        if (
            /iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(
                navigator.userAgent.toLowerCase()
            )
        )
            platform = 'mobile';
        var browsrObj;
        try {
            browsrObj = {
                platform: platform,
                browser: bName,
                versionFull: version,
                versionShort: version.split('.')[0],
            };
        } catch (err) {
            browsrObj = {
                platform: platform,
                browser: 'unknown',
                versionFull: 'unknown',
                versionShort: 'unknown',
            };
        }
        return browsrObj;
    }

    function fixForDifferentBro() {
        var runGetBro = getBrowser();

        // for close modal for iphone safari
        if ($('.modal-window_with-logo').length > 0) {
            if (runGetBro.browser === 'safari') {
                if (runGetBro.platform === 'mobile') {
                    $(window).on('mouseup', function (etg) {
                        if (
                            $(etg.target).closest('.modal-confirm-box').length < 1 &&
                            $(etg.target).closest('.modal-sendanket').length < 1 &&
                            $(etg.target).closest('#ans-modal').length < 1
                        ) {
                            $('.modal-window_with-logo').css('display', 'none');
                        }
                    });
                    // for submit form in iphone safari
                    if ($('#ans-modal').length > 0) {
                        $('#ans-modal')
                            .find('.safari-submit')
                            .on('click', function () {
                                $(this).closest('form').submit();
                            });
                    }
                }
            }
        }
    }

    fixForDifferentBro();
     */

    // js for hide/show price in basket when mouseover in basket

    // $('.short_cart').on('mouseenter', function () {
    //   if ($(this).find('.basket-sm_amount').length > 0) {
    //     $(this).find('.basket-sm_amount').show();
    //   }
    // });
    // $('.short_cart').on('mouseleave', function () {
    //   if ($(this).find('.basket-sm_amount').length > 0) {
    //     $(this).find('.basket-sm_amount').hide();
    //   }
    // });

    // js open/close langswitch in mobile
    $('.mobile-langbox')
        .children('.moblang-trigger')
        .on('click', function () {
            $(this).siblings('.moblang-drop').slideToggle();
        });

    /*** ============ Инициализация слайдера продуктов(good-slider) на странице продукта =========== ***/
    /*
    var goodSlider = new Swiper('.good-slider .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            993: {
                slidesPerView: 4,
                spaceBetweenSlides: 30,
            },
        },
    });
     */

    /*** ============ Инициализация слайдера рекомендуемых продуктов(similar-slider) на странице продукта =========== ***/
    /*
    var similarSlider = new Swiper('.n-arrows .swiper-container', {
        slidesPerView: 1,
        observer: true,
        observerParents: true,
        observerSliseChildren: true,
        spaceBetween: 0,
        initialSlide: 0,
        navigation: {
            nextEl: '.swiper-button-next.similar',
            prevEl: '.swiper-button-prev.similar',
        },
        breakpoints: {
            559: {
                slidesPerView: 2,
                spaceBetweenSlides: 20,
            },
            993: {
                slidesPerView: 'auto',
                spaceBetweenSlides: 30,
            },
        },
    });
     */

    /*
    var otherSlider = new Swiper('.w-arrows .swiper-container', {
        slidesPerView: 1,
        observer: true,
        observerParents: true,
        observerSliseChildren: true,
        spaceBetween: 0,
        initialSlide: 0,
        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: '.swiper-button-next.other',
            prevEl: '.swiper-button-prev.other',
        },
        breakpoints: {
            559: {
                slidesPerView: 2,
                spaceBetweenSlides: 20,
            },
            993: {
                slidesPerView: 'auto',
                spaceBetweenSlides: 30,
            },
        },
    });
     */

    /*** ============ Убираем откритые вкладки на странице продукта для версии (<=768px) =========== ***/
    const goodTabsWr = $('.good_tabs');
    if (goodTabsWr) {
        var widthW = $(window).width();
        if (widthW < 768) {
            $('.btn-mob-trigger').removeClass('open');
            $('.good_tabs_section').removeClass('active');

        }
    }

    /*** ============ Откритие/закритие вкладок на странице продукта для версии (<=992px) =========== ***/
    $('.btn-mob-trigger').on('click', function () {
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $(this).siblings('.good_tabs_section').removeClass('active');
        } else {
            $(this).addClass('open');
            $(this).siblings('.good_tabs_section').addClass('active');
        }
    });

    const faqAccordion = $('.faq-accordion');
    if (faqAccordion) {
        $('.faq-accordion__btn').on('click', function () {
            if ($(this).hasClass('open')) {
                $(this).removeClass('open');
                $(this).siblings('.faq-accordion__answer').removeClass('active');
            } else {
                $(this).addClass('open');
                $(this).siblings('.faq-accordion__answer').addClass('active');
            }
        });
    }

    // **=========Функционал для переключений картинок в слайдере на странице продукта=========**
    // переключение картинок
    // если существует данный блок
    /*
    if ($('.product-imgbox').length > 0) {
        // если произошел клик по одной из картинок слайдера
        $('.good-slider')
            .find('.swiper-slide')
            .children('picture')
            .find('img')
            .on('click', function () {
                // получаем src этой картинки
                var imagePreview = $(this).attr('data-preview');
                var imageLarge = $(this).attr('data-large');

                // убираем активный класс у всех изображений слайдера
                $('.good-slider')
                    .find('.swiper-slide')
                    .children('picture')
                    .find('img')
                    .removeClass('active');

                // и если блок с картинкой существует
                if ($('.good-imgbox').length > 0) {
                    // и если существует сама картинка в этом блоке
                    if ($('.good-imgbox').children('picture').find('source').length > 0) {
                        // меняем ее
                        $('.good-imgbox').children('picture').find('source').attr('srcset', imagePreview);
                        // и меняем атрибут для ее просмотра в модальном окне
                        $('.good-imgbox').children('picture').find('.img-good').attr('data-large', imageLarge);
                        $('.good-imgbox').children('picture').find('source').attr('data-large', imageLarge);
                    }
                }

                // добавляем активный класс для картинки по которой кликнули
                $(this).addClass('active');
            });
    }
     */

    // Remove preloader js
    // setTimeout(function () {
    //   if ($('.preloaderbox').length > 0) {
    //     $('.preloaderbox').hide();
    //     $('.preloaderbox').remove();
    //   }
    // }, 2000);
    // end Remove preloader js

    // Visual js
    // Ровнение фильтров по левой стороне при условии что товаров меньше 4
    (function () {
        // Если нужные контейнеры существуют на странице
        if ($('#itemContainer').length > 0 && $('.catalog-filtersbox').length > 0) {
            // и если товаров меньше 4
            if ($('#itemContainer').children('.card').length < 4) {
                // Ровняем по левой стороне
                $('.catalog-filtersbox').addClass('a-left');
            }
        }
    })();

    $('.mob-onelevel.tdrop').on('click', function (e) {
        var thisLink = $(this);
        var thisList = thisLink.closest('.mobile-menu_b_t');
        if (!thisLink.parent('.dropdown-menu-trigger').hasClass('open')) {
            e.preventDefault();
            thisList.children('.dropdown-menu-trigger').each(function (i, elem) {
                $(elem).removeClass('open');
                $(elem).children('.dropdown-menu').slideUp();
            });
            thisLink.parent('.dropdown-menu-trigger').addClass('open');
            thisLink.siblings('.dropdown-menu').slideDown();
        }
    });

    // Если это главная страница - присваеваем класс - home для body
    (function () {
        if (window.location.pathname == '/' || window.location.pathname == '/ua/') {
            $('body').addClass('home');
        }
    })();

    $(document).on('change', '.un-check-me', function () {
        var thisCheck = $(this);
        if (thisCheck.prop('checked')) {
            $('.advantagesbox')
                .children('.advantages-item')
                .each(function (i, elem) {
                    $(elem).children('.un-check-me').prop('checked', false);
                });
            thisCheck.prop('checked', true);
        }
    });
    $(document).mouseup(function (e) {
        if ($('.un-check-me').length > 0) {
            var advanBox = $('.advantagesbox');
            if (!advanBox.is(e.target) && advanBox.has(e.target).length === 0) {
                $('.un-check-me').prop('checked', false);
            }
        }
    });

    // Специальная валидация телефонных номеров по заказу клиента
    $('.phone-validate').on('input', function (e) {
        var thisField = $(this);
        setTimeout(function () {
            if (thisField.val() == '38(___)___-__-__' || thisField.val() == '') {
                return false;
            } else if (thisField.val().indexOf('38(0') == -1) {
                thisField.val('');
                thisField.focus();
            }
        }, 100);
    });

    setAriaClickImgHeader();


});

//пересчитываем размеры кликабельной области при изменении размера экрана
$(window).resize(function () {
    setTimeout(function () {
        setAriaClickImgHeader()
    }, 200);
});

var tabs = (function () {
    var init = function () {
        _setUpListners();
    };
    var _setUpListners = function () {
        var existing =
            document.querySelector('.basket_tabs_cnt_cart') ||
            document.querySelector('#basket-popup_cnt');

        if (existing) {
            Array.from(tabControlItem).forEach(function (item) {
                item.addEventListener('click', switchTabs);
            });
        }
    };

    var tabControlItem = document.querySelectorAll('.basket_tabs_controls-item');
    var tabContents = document.querySelectorAll('.basket_tabs_list-item');

    function switchTabs(e) {
        var span = this.querySelector('span');
        if (e.target === this) {
            Array.from(tabControlItem).forEach(function (item, i) {
                item.classList.remove('active');
                tabContents[i].style.display = 'none';
                if (e.target === item) {
                    item.classList.add('active');
                    tabContents[i].style.display = 'block';
                }
            });
        }
    }

    return {
        init: init,
    };
})();
tabs.init();

(function ($) {
    $(function () {
        /*** ============ Функция для определения существования элемента на странице =========== ***/
        $('.new-goods_cnt,.bestseller_cnt,.general-slider_cnt').css(
            'display',
            'block'
        );
        (function () {
            $.fn.exists = function (selector) {
                return $(this).length;
            };
        })();
        /*** ============= Обрезка лишнего текста в карточках мероприятий  ======= ***/
        cutLongString($('.card_t'), 55, false);
        cutLongString($('.card_tx'), 116, false);
        cutLongString($('.bargain_i_tx'), 48, false);
        cutLongString($('.video-materials_i_t'), 52, false);
        cutLongString($('.about-us-says_i_tx'), 99, false);

        /*** ============= Обрезка лишнего текста в карточках мероприятий (master) ======= ***/
        // cutLongString($('.card_t'), 55, false);
        // cutLongString($('.card_tx'), 116, false);
        // cutLongString($('.bargain_i_tx'), 48, false);
        // cutLongString($('.video-materials_i_t'), 52, false);
        // cutLongString($('.about-us-says_i_tx'), 124, false);

        /*** ====================== Мобильное меню ====================== ***/
        // Это старый js, он не работает на айфонах с браузером Chrome отключен 11.12.2018

        // (function () {
        //     var touch = $('#mob-btn'),
        //         menu = $('#mobile-menu'),
        //         closeMenu = $("#mobile-menu_btn_back"),
        //         width = screen.width;
        //     $(touch).on('click', function (e) {
        //         e.preventDefault();
        //         touch.addClass("active");
        //         menu.addClass("st-menu-open");
        //     });
        //     $(closeMenu).on('click', function (e) {
        //         e.preventDefault();
        //         touch.removeClass('active');
        //         menu.removeClass("st-menu-open");
        //     });
        //     $(window).resize(function () {
        //         if (screen.width > 768 && menu.is(':hidden')) {
        //             menu.removeAttr('style');
        //         }
        //     });

        // })();

        /*** ====================== Стилизация селекта ====================== ***
        if ($('.filter-by-type_sel').exists()) {
            $('.filter-by-type_sel').SumoSelect();
            $('#filter-select .SumoSelect').click(function () {
                var placeholder = $(this).find('option').eq(0);
                var attr = placeholder.data('placeholder');
                var optWrapper = $(this).find('.optWrapper');
                var disabledLi = optWrapper.find('.disabled');
                if (attr) {
                    placeholder.remove();
                    disabledLi.remove();
                }
                return false;
            });
        }
        if ($('.filter-by-symptom_sel').exists()) {
            $('.filter-by-symptom_sel').SumoSelect();
        }
        if ($('.form_select').exists()) {
            $('.form_select').each(function () {
                var element = $(this);
                var isAllowSearch =
                    element.attr('sumoselect-allowsearch') !== undefined;
                var searchPlaceholder = isAllowSearch
                    ? element.attr('sumoselect-allowsearch').trim()
                    : '';
                $(this).SumoSelect({
                    placeholder: '',
                    search: isAllowSearch,
                    searchText: searchPlaceholder,
                    nativeOnDevice: ['Opera Mini', 'IEMobile', 'Silk'],
                });

                if (isAllowSearch) {
                    var selParent = $(this).parent;

                    /*
                     * По сути - это копия функции библиотеки jquery.sumoselect.js
                     *     с некоторыми изенениями для amrita.ua
                     *
                     * Исходник: https://github.com/HemantNegi/jquery.sumoselect/blob/daa5e37b66f314490ee12ecf99c336ca4f73d19f/jquery.sumoselect.js#L272
                     *
                    this.sumo.Search = function () {
                        // Ничего не делаем если нету optDiv
                        // Связано с тем, что в настройках SumoSelect указаны
                        //     устройства для которых SumoSelect работает в нативном режиме
                        if (!this.optDiv) {
                            return false;
                        }

                          var O = this,
                            cc = O.CaptionCont.addClass('search'),
                            P = $('<p class="no-match">');

                        // Удаляем предыдущий <input> (если есть)
                        !O.ftxt || O.ftxt.remove();

                        O.ftxt = $(
                            '<input type="text" class="search-txt" value="" placeholder="' +
                            searchPlaceholder +
                            '">'
                        ).on('click', function (e) {
                            e.stopPropagation();
                        });
                        cc.append(O.ftxt);

                        // Удаляем предыдущий <p class="no-match"> (если есть)
                        if (O.optDiv.children('ul').next('p.no-match').exists()) {
                            O.optDiv.children('ul').next('p.no-match').remove();
                        }

                        O.optDiv.children('ul').after(P);

                        O.ftxt.on('keyup.sumo', function () {
                            var hid = O.optDiv
                                .find('ul.options li.opt')
                                .each(function (ix, e) {
                                    var e = $(e),
                                        opt = e.data('opt')[0];

                                    // Предыдущий поиск
                                    // opt.hidden = e.text().toLowerCase().indexOf(O.ftxt.val().toLowerCase()) < 0;

                                    // Уникальный поиск для amrita.ua
                                    // Пример регулярки: /^Киев/gi
                                    var re = RegExp(
                                        '^' +
                                        O.ftxt
                                            .val()
                                            .toLowerCase()
                                            .replace(/([^\w\d])/gi, '\\$1'),
                                        'i'
                                    );
                                    opt.hidden = !e.text().toLowerCase().match(re);

                                    e.toggleClass('hidden', opt.hidden);
                                })
                                .not('.hidden');

                            P.html(
                                'No matches for "{0}"'.replace(/\{0\}/g, '<em></em>')
                            ).toggle(!hid.length);
                            P.find('em').text(O.ftxt.val());
                            O.selAllState();
                        });
                    };

                    this.sumo.Search();
                }
            });
            $('.form_field .SumoSelect').click(function () {
                var placeholder = $(this).find('option').eq(0);
                var attr = placeholder.data('placeholder');
                var optWrapper = $(this).find('.optWrapper');
                var disabledLi = optWrapper.find('.disabled');
                if (attr) {
                    placeholder.remove();
                    disabledLi.remove();
                }
                return false;
            });
        }
        if ($('.count_sel').exists()) {
            $('.count_sel').SumoSelect();
        }
        /*** ====================== Выбор спонсора попап ====================== ***/
        $('.registration-online .link-ch-s').click(function (e) {
            e.preventDefault();
            $('.reg_popup').show();
        });
        $('.reg_popup .close').click(function () {
            $(this).closest('.outer').hide();
        });
        /*** ====================== Слайдеры ====================== ***/
        if ($('#general-slider_cnt').exists()) {
            // если в слайдере на главной только одна картинка
            if ($('#general-slider_cnt').hasClass('one')) {
                $('#general-slider_cnt').owlCarousel({
                    nav: true,
                    autoplay: true,
                    autoplayTimeout: 4000,
                    autoplayHoverPause: true,
                    items: 1,
                    animateOut: 'fadeOut',
                    dots: true,
                });
            } else {
                $('#general-slider_cnt').owlCarousel({
                    loop: true,
                    nav: true,
                    autoplay: true,
                    autoplayTimeout: 4000,
                    autoplayHoverPause: true,
                    items: 1,
                    animateOut: 'fadeOut',
                    dots: true,
                });
            }
        }
        /*** ====================== Слайдера на главное рекламный блок (справа)====================== ***/
        // if ($('#general-slider_cnt-right').exists()) {
        //     // если в слайдере на главной только одна картинка
        //     if ($('#general-slider_cnt-right').hasClass('one')) {
        //         $('#general-slider_cnt-right').owlCarousel({
        //             nav: true,
        //             autoplay: true,
        //             autoplayTimeout: 4000,
        //             autoplayHoverPause: true,
        //             items: 1,
        //             animateOut: 'fadeOut',
        //             dots: true,
        //         });
        //     } else {
        //         $('#general-slider_cnt-right').owlCarousel({
        //             loop: true,
        //             nav: true,
        //             autoplay: true,
        //             autoplayTimeout: 4000,
        //             autoplayHoverPause: true,
        //             items: 1,
        //             animateOut: 'fadeOut',
        //             dots: true,
        //         });
        //     }
        // }

        if ($('.general-slider_cnt.rslider').length > 0) {
            $('.general-slider_cnt.rslider').owlCarousel({
                loop: true,
                nav: false,
                autoplay: true,
                autoplayTimeout: 3000,
                autoplayHoverPause: true,
                items: 1,
                animateOut: 'fadeOut',
                dots: true,
            });
        }
        // if ($('.new-goods_cnt').exists()) {
        //     $(".new-goods_cnt").owlCarousel({
        //         loop: false,
        //         nav: true,
        //         items: 3,
        //         dots: false,
        //         lazyLoad: true,
        //         responsive: {
        //             0: {
        //                 items: 1
        //             },
        //             650: {
        //                 items: 2
        //             },
        //             768: {
        //                 items: 1
        //             },
        //             992: {
        //                 items: 2
        //             },
        //             1200: {
        //                 items: 3
        //             }
        //         }
        //     });
        // }
        if ($('.bestseller_cnt').exists()) {
            $('.bestseller_cnt').owlCarousel({
                loop: false,
                nav: true,
                items: 3,
                dots: false,
                lazyLoad: true,
                responsive: {
                    0: {
                        items: 1,
                    },
                    650: {
                        items: 2,
                    },
                    768: {
                        items: 1,
                    },
                    992: {
                        items: 2,
                    },
                    1200: {
                        items: 3,
                    },
                },
            });
            $('.bestseller_cnt_prom').owlCarousel({
                loop: false,
                nav: true,
                items: 3,
                dots: false,
                lazyLoad: true,
                responsive: {
                    0: {
                        items: 1,
                    },
                    650: {
                        items: 2,
                    },
                    768: {
                        items: 1,
                    },
                    992: {
                        items: 2,
                    },
                    1024: {
                        items: 3,
                    },
                    1200: {
                        items: 4,
                    },
                },
            });
        }
        if ($('.video-materials_i_video').exists()) {
            $('.video-materials_i_video').fancybox({
                maxWidth: 800,
                openEffect: 'elastic',
                maxHeight: 600,
                fitToView: false,
                width: '70%',
                height: '70%',
                autoSize: false,
                closeClick: false,
                openEffect: 'none',
                closeEffect: 'none',
                helpers: {
                    overlay: {
                        locked: false,
                    },
                },
            });
        }

        /*** ============ Откритие/закритие вкладок на странице продукта для версии (993px > ...) =========== ***/
        $('.good_tabs_lk').click(function () {
            var section = $(this).data('section');
            if (section != $('.good_tabs_lk.good_tabs_lk_active').data('section')) {
                $('.good_tabs_lk').removeClass('good_tabs_lk_active');
                $(this).addClass('good_tabs_lk_active');
                $('.good_tabs_section').removeClass('active');
                $(section).addClass('active');
            }
            return false;
        });

        /*** ============ скролл к вкладке ПРИМИНЕНИЕ на странице продукта для версии (993px > ...) =========== ***/
        $('.prod-description-details').on('click', function () {
            $('html,body').animate({
                scrollTop: $('[data-section="#section-4"]').offset().top + "px"
            }, {duration: 1E3});
            openTab();
        });

        /*** ============ скролл к вкладке ПРИМИНЕНИЕ на странице продукта для версии (<=992px) =========== ***/
        $('.prod-description-details').on('click', function () {
            openTab();
            $('.btn-mob-trigger').removeClass('open');
            $('#section-4').siblings('.btn-mob-trigger').addClass('open');
            $('html,body').animate({
                scrollTop: $('#section-4').offset().top + "px"
            }, {duration: .3E3});
        });

        /*** ============ функция для Откритие/закритие вкладки ПРИМИНЕНИЕ при скролле =========== ***/
        function openTab() {
            var needTab = $('.good_tabs_lk');
            if (needTab) {
                var section = $('[data-section="#section-4"]').data('section');
                if (section != $('.good_tabs_lk.good_tabs_lk_active').data('section')) {
                    $('.good_tabs_lk').removeClass('good_tabs_lk_active');
                    $('[data-section="#section-4"]').addClass('good_tabs_lk_active');
                    $('.good_tabs_section').removeClass('active');
                    $(section).addClass('active');
                }
            }
        }

        $('#good_zoom').click(function () {
            var href = $(this)
                .closest('.good_b')
                .siblings('.good_img')
                .find('img')
                .data('large');
            $.fancybox.open({
                href: href,
                maxWidth: 800,
                openEffect: 'elastic',
                maxHeight: 600,
                fitToView: false,
                width: '70%',
                height: '70%',
                autoSize: false,
                closeClick: false,
                openEffect: 'none',
                closeEffect: 'none',
                helpers: {
                    overlay: {
                        locked: false,
                    },
                },
            });
            return false;
        });

        if ($('.product-imgbox').length > 0) {
            $('.product-imgbox').on('click', '.img-good', function () {
                var href = $(this).attr('data-large');
                $.fancybox.open({
                    href: href,
                    maxWidth: 800,
                    openEffect: 'elastic',
                    maxHeight: 600,
                    fitToView: false,
                    width: '70%',
                    height: '70%',
                    autoSize: false,
                    closeClick: false,
                    openEffect: 'none',
                    closeEffect: 'none',
                    helpers: {
                        overlay: {
                            locked: false,
                        },
                    },
                });
                return false;
            });
        }

        function setFancyboxGoodSlider() {
            $('.product-imgbox .good-slider .swiper-slide').on('click', 'img', function () {
              if ($('.product-imgbox .good-slider').length > 0 && window.innerWidth <= 990) {
                var href = $(this).attr('data-large');
                $.fancybox.open({
                    href: href,
                    openEffect: 'elastic',
                    autoWidth: true,
                    closeClick: false,
                    openEffect: 'none',
                    closeEffect: 'none',
                    helpers: {
                        overlay: {
                            locked: false,
                        },
                    },
                });
                return false;
            }
          });
        }
        // setFancyboxGoodSlider();
        $(window).resize(function () {
          // setFancyboxGoodSlider();
        });

        /*** ====================== Каталог меню (мобильное) ====================== ***/
        $('.filter-by-cat_t').on('click', function (e) {
            e.preventDefault();
            var filterByCatMenu = $(this).siblings('.filter-by-cat_menu');
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                filterByCatMenu.removeClass('open');
            } else {
                $(this).addClass('active');
                filterByCatMenu.addClass('open');
            }
        });
        $('.filter-by-cat_menu li').click(function () {
            if ($(this).find('> .filter-by-cat_submenu').length == 1) {
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $(this).find('> .filter-by-cat_submenu').slideUp();
                } else {
                    $(this).addClass('active');
                    $(this).find('> .filter-by-cat_submenu').slideDown();
                }
            } else {
                window.location = $(this).find('> a').attr('href');
            }
            return false;
        });
        $('.good_liked').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
        });

        $('#overlay').click(function () {
            $('#personal-area').animate(
                {opacity: 0, marginTop: '0'},
                200,
                function () {
                    $(this).css('visibility', 'hidden');
                    $('#overlay').fadeOut(400);
                }
            );
        });
        $('#personal-area .modal-content_close').click(function (e) {
            e.preventDefault();
            $('#personal-area').animate(
                {opacity: 0, marginTop: '0'},
                200,
                function () {
                    $(this).css('visibility', 'hidden');
                    $('#overlay').fadeOut(400);
                }
            );
        });

        if ($('.basket-popup_cnt').exists()) {
            // $('.basket-popup_cnt').jScrollPane();
            var api = $('.basket-popup_cnt').data('jsp');
            var throttleTimeout;
            $(window).bind('resize', function () {
                if (!throttleTimeout) {
                    throttleTimeout = setTimeout(function () {
                        api.reinitialise();
                        throttleTimeout = null;
                    }, 50);
                }
            });
        }

        /*** ====================== mobile-accordion ====================== ***/
        $('.mobile-accordion_t').click(function (e) {
            var currentAttrValue = $(this).attr('href');
            if ($(e.target).is('.active')) {
                close_accordion_section();
            } else {
                close_accordion_section();
                $(this).addClass('active');
                $('.mobile-accordion ' + currentAttrValue)
                    .slideDown(300)
                    .addClass('open');
            }
            e.preventDefault();
        });

        /*** ====================== Постраничная навигация в мобильной версии каталога ====================== ***
        if ($('.catalog_holder').exists()) {
            var initialization = false;
            $(window).resize(function () {
                JPages();
            });
            JPages();

            function JPages() {
                var widthW = $(window).width();
                if (!initialization && widthW < 768) {
                    $('div.catalog_holder').jPages({
                        containerID: 'itemContainer',
                        fallback: 500,
                        perPage: 3,
                        midRange: 4,
                        callback: function () {
                            initialization = true;
                        },
                    });
                } else if (initialization && widthW > 768) {
                    $('div.catalog_holder').jPages('destroy');
                    $('#itemContainer .card').each(function () {
                        $(this).show();
                    });
                    initialization = false;
                }
            }
        } */
    });

    function close_accordion_section() {
        $('.mobile-accordion .mobile-accordion_t').removeClass('active');
        $('.mobile-accordion .mobile-accordion_cnt')
            .slideUp(300)
            .removeClass('open');
    }

    function cutLongString(element, count_lit, blackout) {
        element.each(function () {
            var itemEl = $(this);
            var text = itemEl.html();
            var all_len = text.length;
            var new_text;
            if (all_len > count_lit) {
                new_text = text.substr(0, count_lit - 3) + '...';
                if (blackout) {
                    var first_part_text = new_text.substr(0, count_lit - 6);
                    var light_part_text = new_text.substr(count_lit - 6, count_lit);
                    var light_text = '';
                    var array_color = [
                        '#000',
                        '#414040',
                        '#5a5a5a',
                        '#a3a3a3',
                        '#cccccc',
                        '#ffffff',
                    ];
                    for (var i = 0; i < 6; i++) {
                        light_text +=
                            "<span style='color: " +
                            array_color[i] +
                            "'>" +
                            light_part_text.substr(i, 1) +
                            '</span>';
                    }
                    new_text = first_part_text + light_text;
                }
                itemEl.html(new_text);
            }
        });
    }
})(jQuery);

function answerHistory(url, action_type, form_id) {
    $.ajax({
        method: 'GET',
        url: url,
        data: {
            action_type: action_type,
            form_id: form_id,
        },
        success: function (data) {
            console.log(data);
        },
    });
}

function answerHistoryOrder(url, month, form_id) {
    $.ajax({
        method: 'GET',
        url: url,
        data: {
            action_type: 'order',
            month: month,
            form_id: form_id,
        },
        success: function (data) {
            console.log(data);
        },
    });
}

var baseUrl = $("meta[name=js_base_url]").attr("content");

/**
 * Not remind form
 */
function notRemindQuestionnaireForm(id) {
    $.post(baseUrl + 'wellness-consultant/ajax-not-remind/', {
        _csrf: $('#token').val(),
        id: id,
    }).done(function (data) {
        if (data == true) {
        }
    });
}

// инициализация LazyLoad
// var lazyLoadInstance = new LazyLoad({
//     elements_selector: '.lazy',
// });

// если на странице есть блок с реферальной ссылкой еопирование ссылки
if ($('.referal-block').length > 0) {
    var referalLink = document.querySelector('.referal-link');
    var textBlock = document.querySelector('.referal-text');
    var text = referalLink.getAttribute('data-text');
    // обработчик клика
    referalLink.addEventListener('click', function (e) {
        e.preventDefault();
        // получаем значение реферальной ссылки
        var href = this.getAttribute('href');
        // проверяем наличие метода в браузере
        if (navigator.clipboard && window.isSecureContext) {
            // navigator clipboard api метод
            navigator.clipboard
                .writeText(href)
                .then(function () {
                    textBlock.innerText = text; //
                    textBlock.style.color = '#8b53c3';
                })
                .catch(function (err) {
                    console.log('Something went wrong', err);
                });
        } else {
            // text area метод
            var textArea = document.createElement('textarea');
            textArea.value = href;
            // выносим textarea за область видимости
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                //копируем в буфер обмена
                document.execCommand('copy');
                //меняем стили кнопки после копирования
                textBlock.innerText = text;
                textBlock.style.color = '#8b53c3';
            } catch (err) {
                toastr.warning('Was not possible to copy te text: ', err);
            }
            //удаляем блок
            document.body.removeChild(textArea);
        }
    });
}

var visiblePassword = document.getElementById('visible-password');

if (visiblePassword) {
    var inputPassw = document.querySelector('._input-passw');
    visiblePassword.addEventListener('click', function (e) {
        e.preventDefault();
        this.classList.toggle('_active');
        if (inputPassw.type === "password") {
            inputPassw.type = "text";
        } else {
            inputPassw.type = "password";
        }

    })
}

// $('#subCartCustomerForm').on('click', function (e) {
// e.preventDefault();
// var data111 = $('#CartCustomerForm').serializeArray();
// $.each(data111,function(){
//   console.log(this.name+'='+this.value);
// });
// $('#CartCustomerForm').submit();
// data111 = '';
// console.log($('#subCartCustomerForm'), ' subCartCustomerForm');
// })

var sliderRange = document.getElementById('range-slider');
if (sliderRange) {
    //init range slider стартовые значения получаем из data аттрибутов
    noUiSlider.create(sliderRange, {
        start: [+sliderRange.dataset.selectMin, +sliderRange.dataset.selectMax],
        connect: true,
        step: 1,
        range: {
            'min': +sliderRange.dataset.min,
            'max': +sliderRange.dataset.max
        }
    });

    var input0 = document.getElementById('amount_min');
    var input1 = document.getElementById('amount_max');
    var inputs = [input0, input1];
    // при обновлении слайдера меняем значения в полях инпутов
    sliderRange.noUiSlider.on('update', function (values, handle) {
        inputs[handle].value = Math.round(values[handle]);
    });
    sliderRange.noUiSlider.on('change', function (values) {
        $('input[name="price_min"]').val(values[0]);
        $('input[name="price_max"]').val(values[1]);
        $('#catalog_filter').submit();
    })
    //при изменении полей инпутов изменяем слайдер
    inputs.forEach(function (el, indx) {
        el.addEventListener('change', function (e) {
            var arrInpts = [null, null];
            arrInpts[indx] = e.currentTarget.value;
            sliderRange.noUiSlider.set(arrInpts);
        });
    });
}

// скролл к элементу в корзине покупателя при оформлении заказа (выбор города для доставки НП)
var basketPayment = $('.shipping-and-payment_w');
if (basketPayment) {
  function newPostScroll() {
    var chooseCity = $('#cartcustomerform-delivery_novaposhta_city')
    chooseCity.on('click', function () {
      if ($(window).width() <= 590) {
        $('html,body').animate({
          scrollTop: $('.field-delivery-delivery_novaposhta_city').offset().top + "px"
            },
            {
              duration: .2E3
            });
      } else return;
    });
  }
    newPostScroll();
    $( window ).resize(function() {
      newPostScroll();
    });
}

// fixed btn for mobile on product-page
/*
var catalogProductPage = document.querySelector('.body-mobile .section-page-product .product-view')
if (catalogProductPage) {
    // fixed product btn for mobile
    $(document).ready(function () {
        $('.wrapper-order').addClass('block-order-fixed');
        $(document).scroll(function () {
            windowScrollBottom = $(window).scrollTop() + $(window).height();
            buttonPanel = $(".wrapper-advantages").offset().top;
            if (windowScrollBottom > buttonPanel) {
                $('.wrapper-order').removeClass('block-order-fixed');
            } else {
                $('.wrapper-order').addClass('block-order-fixed');
            }
        });
    });
}
*/

function changeUrlImg() {
  var imgInGoodSlider = Array.from(document.querySelectorAll(".good-slider picture"));
  if (window.innerWidth <= 992 && imgInGoodSlider) {
    imgInGoodSlider.forEach(function(el) {
      var _prevLarge = el.querySelector("img[data-preview]").dataset.preview;
      if (_prevLarge) {
        el.querySelector("img[data-preview]").src = window.location.origin + _prevLarge;
        el.querySelector("source").srcset = window.location.origin + _prevLarge;
      }
    });
  }
}
changeUrlImg();
window.addEventListener('resize', changeUrlImg);

// проверка на наличие lazyload и установка аттрибутов высоты/ширины для оптимизации
var imgList = Array.from(document.querySelectorAll('img'));
imgList.forEach(function(el) {
  if (el.loading !== 'lazy') {
    el.loading = 'lazy';
  }
  if (el.getAttribute('width') === '100%') {
    el.setAttribute('width', el.width);
    el.setAttribute('height', el.height);
  }
});

/*
  if (window.location.pathname.includes('/articles/article/')) {
    var btnTopBtn = document.createElement('button');
    btnTopBtn.classList.add('btn-top');
    document.body.append(btnTopBtn);
    var btnTopBtnElement = document.querySelector('.btn-top');
    btnTopBtnElement.addEventListener('click', function() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
    window.addEventListener('scroll', function() {
      if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight) {
        btnTopBtnElement.classList.add('_active');
      } else {
        btnTopBtnElement.classList.remove('_active');
      }
    })
  }
*/

// ширина скрола
function helperGetScrollWidth() {
    var newDiv = document.createElement('div')
    newDiv.style.position = 'absolut'
    newDiv.style.top = '-9999px'
    newDiv.style.width = '50px'
    newDiv.style.height = '50px'
    newDiv.style.overflow = 'scroll'
    newDiv.style.visibility = 'hidden'

    document.body.appendChild(newDiv)
    var width_Scroll = newDiv.offsetWidth - newDiv.clientWidth
    document.body.removeChild(newDiv)
    return width_Scroll
}

console.timeEnd('speed Main js');
